import { createSelector } from "reselect";

/* Return base64 signature Pad */
export const getSignPad = (state) => {
  return state.signatureReducer.signPad;
};

/* Return base64 signature Type */
export const getSignType = (state) => {
  return state.signatureReducer.signType;
};

/* Return true if is empty */
export const isSignatureEmpty = (state) => {
  return state.signatureReducer.isEmpty;
};

export const getSignature = createSelector(
  [getSignPad, isSignatureEmpty, getSignType],
  (signPad) => {
    return signPad;
  },
  (signType) => {
    return signType;
  },
  (isEmpty) => {
    return isEmpty;
  }
);



// WEBPACK FOOTER //
// ./src/modules/NTICore/component/Signature/selector.js